import { STRAPI_URL } from "../env";

export async function importItems(
  file: File,
  mapping: Record<string, string>,
  projectId?: string,
  headerRowIndex?: number,
  dataStartRowIndex?: number
) {
  const formData = new FormData();
  formData.append("files", file);
  formData.append("mapping", JSON.stringify(mapping));

  if (projectId) {
    formData.append("projectId", projectId);
  }
  if (headerRowIndex !== undefined) {
    formData.append("headerRowIndex", headerRowIndex.toString());
  }
  if (dataStartRowIndex !== undefined) {
    formData.append("dataStartRowIndex", dataStartRowIndex.toString());
  }

  const url = `${STRAPI_URL}/excel-import/import-with-mapping`;

  try {
    const response = await fetch(url, {
      method: "POST",
      credentials: "include",
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("[ExcelImport] Server error:", errorText);
      throw new Error(
        `Server error ${response.status}: ${response.statusText}. ${errorText}`
      );
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("[ExcelImport] Network/Parse error:", error);
    throw error;
  }
}

export async function parseExcelHeaders(file: File) {
  const formData = new FormData();
  formData.append("files", file);

  try {
    const url = `${STRAPI_URL}/excel-import/headers`;
    const response = await fetch(url, {
      method: "POST",
      credentials: "include",
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("[ExcelImport] Headers server error:", errorText);
      throw new Error(
        `Failed to parse Excel headers: ${response.status} ${response.statusText}. ${errorText}`
      );
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error parsing Excel headers:", error);
    throw error;
  }
}
